import {createReducer} from "redux-act";
import {fetchChecksumsJSONSuccess} from "apps/BUDWEISERPOTM/modules/actions";
import {IDictionary} from "modules/types";

export interface ILiveScoring {
	checksums: IDictionary<string>;
}

const initial = {
	checksums: {},
};

export const liveScoring = createReducer({}, initial).on(
	fetchChecksumsJSONSuccess,
	(state, payload) => ({
		...state,
		checksums: payload,
	})
);
